import { css, makeStyles } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  userInfoText: theme => css`
    color: ${theme.colors.neutral[200]};
    @media (max-width: ${theme.grid.breakpoint.sm}) {
      display: flex;
      justify-content: center;
    }
  `,
})

export { useStyles }
